<template>
  <el-collapse v-model="activeNames" @change="handleChange">
    <el-collapse-item :title="item.title" :name="item.title" v-for="item in news" key="item">
      <div v-for="line in item.data" :key="line">
        <div style="min-height: 23px">{{line}}</div>
      </div>
    </el-collapse-item>
  </el-collapse>
</template>

<script>
  export default {
    data() {
      return {
        activeNames: ['1'],
        news: [{
          title: 'News',
          data: [
            
            'July 22, 2022: Adam submits final Masters thesis',
            '',
            'May 22, 2022: Mira passes here per-submission meeting',
            '',
            'April 13, 2022: The manuscript on "Recent advances in optical label-free characterization of extracellular vesicles" is published in the journal Nanophotonics',    
            '',
            'Feburary, 2022: Sebastian and Juanjuan receive TechAccelR grant  for the project “On-Chip Chemiluminescence Biosensor for Food Safety” ',
            '',
            'Feburary, 2022: Sebastian and Juanjuan receive NSERC Idea to Innovation (I2I) grant  for the project “Market Assessment: Market analysis for monitoring gout disease at the point of need using a CMOS-based device” ',
            '',
            'Feburary 9, 2022: The manuscript on "SE-ECL on CMOS: a miniaturized electrochemiluminescence biosensor" is published in the journal Lab on a Chip',    
            '',
            'August, 2021: Sebastian is awarded Louis-Ho Faculty Scholar in Technological Innovation',
            '',
            'August 19, 2021: Juanjuan passed her Ph.D. oral defence ',
            '',
            'July 14, 2021: The manuscript on "Multimodal electrochemical and SERS platform for chlorfenapyr detection" is published in the journal Applied Surface Science',
            '',
            'June 7, 2021: The manuscript on "Identification of amyloid beta in small extracellular vesicles via Raman spectroscopy" is published in the journal Nanoscale Advances',
            '',
            'April 12, 2021: Sara passed her Ph.D. oral defence ',
            '',
            'September 2, 2020: The manuscript on "Superhydrophobic bowl-like SERS substrates patterned from CMOS sensors for extracellular vesicle characterization" is published in the Journal of Materials Chemistry B',
            '',
            'September 1, 2020: Adam joins the lab as a master\'\s student',
            '',
            'September 1, 2020: The manuscript on "Lensless, reflection-based dark-field microscopy (RDFM) on a CMOS chip" is published in the journal Biomedical Optics Express',
            '',
            'August 31, 2020: Reza passes his pre-comprehensive meeting',
            '',
            'June 12, 2020: The manuscript on "An AgNP-deposited commercial electrochemistry test strip as a platform for urea detection" is published in the journal Scientific Reports',
            '',
            'May 19, 2020: Mira passes her comprehensive meeting',
            '',
            'February 6, 2020: Sebastian gives an invited talk on "Raman spectroscopy for the analysis of exosomes" at SPIE Photonics West Conference',
            '',
            'February 3, 2020: An oral presentations about "Direct on-sensor imaging for shadow-based microparticle characterization and bioluminescence imaging" is given at SPIE Photonics West Conference',
            '',
            'February 2, 2020: An oral presentations about "AgNP-decorated 3D nano-bowl structures for SERS detection of urea and exosomes" is given at SPIE Photonics West Conference',
            '',
            'January 13, 2020: Juanjuan passes her progress meeting',
            '',
            'December 13, 2019: An editorial on "Plasmonic Technologies for Bioanalytical Applications" is published in the journal Frontiers in Chemistry',
            '',
            'December 12, 2019: The manuscript on "Are plasmonic optical biosensors ready for use in point-of-need applications?" is published in the journal Analyst',
            '',
            'December 10, 2019: Sara passes her pre-submission meeting',
            '',
            'November, 2019: Sebastian receives 3-year DND funding as part of the DND-IDEAS Network together with other insitutions in Canada, USA, and Europe',
            '',
            'November 26, 2019: Reza passes his preliminary meeting',
            '',
            'October 30, 2019: Meruyert passes her pre-comprehensive meeting',
            '',
            'September 1, 2019: Reza joins the lab as a PhD student',
            '',
            'August 2, 2019: The manuscript on phase contrast imaging with dual-phone illumination-imaging system is published in the journal Biomedical Optics Express and it is chosen as the Editor\'s pick',
            '',        
            'July 21, 2019: Juanjuan and Meruyert went to Center for Biophotonics, UC Davis in Sacramento for a short research exchange. This trip was funded by Graduate Mobility Award (GMA)',
            '',
            'July 1, 2019: Sorina joins the lab as a postdoctoral fellow',
            '',
            'April 23, 2019: Meruyert passes her preliminary qualifying meeting exam',
            '',
            'February 18, 2019, Reem joins the lab as a visiting MSc student',
            '',
            'February 4, 2019: Sara gives an oral presentation at SPIE Photonics West Conference',
            '',
            'February 3, 2019: Juanjuan gives an oral presentation at SPIE Photonics West Conference',
            '',
            'February 3, 2019: Sebastian gives an oral presentation at SPIE Photonics West Conference',
            '',
            'January 30, 2019: the manuscript on dual-phone illumination-imaging system is published in the journal Lab on a Chip',
            '',
            'January 7, 2019, Meruyert joins the lab as a PhD student. She is the recipient of a highly prestigious Bolashak scholarship',
            '',
            'November 21, 2018: Juanjuan passes her PhD comprehensive exam',
            '',
            'August 18, 2018: the manuscript on bionanocomposite materials for biosensing is now published in the journal ACS Applied Nano Materials',
            '',
            'August 12, 2018: second manuscript in a year on Alzheimer’s disease is now published in collaboration with colleagues at UC Davis: https://twitter.com/Molecules_MDPI/status/1028845646634078208',
            '',
            'July 3, 2018: manuscript on light scattering was accepted for publication. More to follow.',
            '',
            'June 11, 2018: Sebastian gives invited presentation at ICASS 2018 in Toronto',
            '',
            'June 7, 2018: Sara has an oral presentation at SPIE Photonics North conference',
             '',
            'June 6, 2018: Juanjuan gives a poster presentation at SPIE Photonics North conference',
             '',
            'May 16, 2018: Juanjuan passes the PhD comprehensive preparation exam',
            '',
            'April 2018: Sebastian is awarded a 5 year NSERC Discovery grant',
            '',
            'March 5, 2018: Sebastian presents at the Pathology Grand Rounds at UC Davis on “Novel Photonic technologies for diagnosis"',
            '',
            'March 2018: Sebastian is awarded a CAD 0.5M equipment grant',
            '',
            'December 7, 2017: Sara passes her PhD comprehensive exam',
             '',
            'December 5, 2017: Sebastian gives invited presentation at the University of Basel Switzerland',
            '',
            'November 16, 2017: Juanjuan passes her preliminary qualifying meeting exam',
            '',
            'November 10, 2017: Sebastian gives invited presentation at Iowa State University, Ames, as part of the SAS tour speaker',
            '',
            'November 8, 2017: Sebastian gives invited presentation at Maryville University, St. Louis, as part of the SAS tour speaker',
            '',
            'September 16, 2017: Sebastian gives invited presentation at Purdue symposium as part of the SAS tour speaker',
            
            
                    
          ]
        },{
          title: 'Feedback',
          data: [
            'To be updated.',
            ''
          ]
        },]
      };
    },
    methods: {
      handleChange: () => {

      }
    }
  };
</script>



// WEBPACK FOOTER //
// src/components/content/home/News.vue